import { applyMiddleware, compose, legacy_createStore, type Store } from 'redux'
import promiseMiddleware from 'redux-promise-middleware'
import thunk from 'redux-thunk'

import rootReducer, { type RootState } from './reducers'

const composeEnhancers = compose
const enhancer = composeEnhancers(
  applyMiddleware(thunk as never, promiseMiddleware() as never),
)

const createReduxStore = legacy_createStore as unknown as (
  reducer: typeof rootReducer,
  preloadedState: Partial<RootState> | undefined,
  enhancerArg: typeof enhancer,
) => Store<RootState>

export default function configureStore(
  initialState?: Partial<RootState>,
): Store<RootState> {
  const store = createReduxStore(rootReducer, initialState, enhancer)
  return store
}
